module.exports = __webpack_public_path__ + "img/1_3x.70e89313.png";